import { useState, useRef, useEffect } from "react";
import iconKebab from "../assets/icon-kebab.svg";
import iconEdit from "../assets/icon-edit.svg";
import iconTrash from "../assets/icon-trash.svg";

interface KebabMenuProps {
  onEdit: () => void;
  onDelete: () => void;
}

export function KebabMenu({ onEdit, onDelete }: Readonly<KebabMenuProps>) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        aria-label="Actions"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        className="p-1 rounded hover:bg-hover-light"
      >
        <img src={iconKebab} alt="" width={20} height={20} />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-[140px] bg-bg-primary rounded-2xl shadow-[0_6px_12px_var(--color-shadow-dropdown)] z-10 overflow-hidden">
          <button
            onClick={() => {
              onEdit();
              setOpen(false);
            }}
            className="flex items-center gap-2 w-full px-4 py-3 text-sm text-text-primary hover:bg-bg-secondary"
          >
            <img src={iconEdit} alt="" width={16} height={16} />{" "}
            Edit
          </button>
          <button
            onClick={() => {
              onDelete();
              setOpen(false);
            }}
            className="flex items-center gap-2 w-full px-4 py-3 text-sm text-system-red hover:bg-bg-secondary"
          >
            <img src={iconTrash} alt="" width={16} height={16} />{" "}
            Delete
          </button>
        </div>
      )}
    </div>
  );
}
